import { SearchVehicles } from "../../../FormComponents/AddLoad/AdddLoad.Config";

export const Award_Accepted_Fields = [
  {
    id: Math.random() * 10,
    name: "Award_Accepted",
    fields: [
      {
        id: Math.random() * 10,
        name: "Vehicle_Number",
        label: "Vehicle Number",
        type: "InputDropForQuery",
        dropdowncontent: SearchVehicles,
        Reference_field: "SpId",
        EMTQuery: {
          headers: { "X-GraphQL-Server": "secondary" },
        },
        min: 2,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Driver_Name",
        label: "Driver Name",
        type: "text",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Driver_Number",
        label: "Driver Number",
        type: "number",
        min: 10,
        max: 10,
      },
      {
        id: Math.random() * 10,
        name: "Reporting_Time",
        label: "Reporting Time",
        type: "time",
        dropdowncontent: ["8:00 Am", "8:30 Am", "9:00 Am", "9:30 Am", "9:30 Am"],
        min: 2,
        max: Infinity,
      },
    ],
  },
];
